import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';

export const UnauthorizedOverlay: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    const t = setTimeout(() => history.push('/'), 5000);
    return () => clearTimeout(t);
  }, [history]);

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          p: 2,
          textAlign: 'center',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        },
      }}
    >
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            bgcolor: 'rgba(16, 185, 129, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2.5,
            color: 'primary.main',
          }}
        >
          <ShieldRoundedIcon sx={{ fontSize: 40 }} />
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: 'text.primary' }}>
          Unauthorized
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, maxWidth: 280 }}>
          You don’t have permission to view this page. Please contact your administrator.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={() => history.push('/')}
          sx={{
            borderRadius: '9999px',
            px: 4,
            py: 1,
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: 'none',
          }}
        >
          Go Home Now
        </Button>
      </DialogContent>
    </Dialog>
  );
};
